<template>
    <div class="apprentice-multi-step-form">
        <slot name="header"></slot>
        <div
            class="vue-form-step"
            v-for="(step, index) in steps"
            v-show="activeStepIndex === index"
            :key="index"
            :id="'step' + (index + 1)">
            <slot :name="'step' + (index + 1)"></slot>
        </div>

        <footer v-if="!hideFooter">
            <slot name="footer">
                <b-button
                    class="btn-chevron-left btn-previous-step"
                    v-if="!isFirstStep()"
                    variant="primary"
                    @click="previousStep">
                    {{ $t('common.message.previous') }}
                </b-button>

                <b-button
                    class="btn-save btn-store-form"
                    v-if="isLastStep()"
                    variant="primary"
                    @click="submitForm">
                    {{ $t('common.message.sent') }}
                </b-button>

                <b-button
                    class="btn-next-step btn-after-chevron-right"
                    v-if="!isLastStep()"
                    variant="primary"
                    @click="nextStep">
                    {{ $t('common.message.next') }}
                </b-button>
            </slot>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'design-2021-simple-multi-steps-form-component',
    props: {
        steps: {
            type: Array,
            required: true,
        },
        hideFooter: {
            type: Boolean,
            required: false,
            default: false,
        },
        startStepIndex: {
            type: Number,
            required: false,
            default: 0,
        },
    },

    data() {
        return {
            activeStepIndex: this.startStepIndex !== 0 ? this.startStepIndex : 0,
        };
    },

    methods: {
        submitForm() {
            this.$emit('submit-form');
        },

        previousStep() {
            this.activeStepIndex--;
        },

        nextStep() {
            if (!this.steps[this.activeStepIndex].step_valid && !this.steps[this.activeStepIndex].step_skip) {
                this.$emit('validate-step', this.activeStepIndex);
                return false;
            }

            this.activeStepIndex++;
        },

        isFirstStep() {
            return this.activeStepIndex === 0;
        },

        isLastStep() {
            return this.activeStepIndex === this.steps.length - 1;
        },
    },
};
</script>

<style scoped lang="scss">
footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: $grid-gutter-width;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
